import { z } from 'zod'
import { oc } from '@orpc/contract'
import { identityStatusSchema } from '../../patient/handlers/patient-identity.contract'

// Super **Persona pilot** page (docs/PERSONA_IDV_PLAN.md §9, step 2.2): the pilot cohort, who
// enrolled or removed whom and when, and why Persona is or is not being offered. The
// `persona-idv-pilot` flag is shown read-only — it is changed in LaunchDarkly, never here.

const flagStateSchema = z.enum(['on', 'off', 'unconfigured', 'unavailable', 'local_on'])

const cohortMemberSchema = z.object({
  patientId: z.string(),
  patientName: z.string().optional(),
  active: z.boolean(),
  enrolledAt: z.string().optional(),
  enrolledBy: z.string().optional(),
  removedAt: z.string().optional(),
  removedBy: z.string().optional(),
  removalReason: z.string().optional(),
  /** Only for active entries — the patient's status now. */
  identityStatus: identityStatusSchema.optional(),
  /** Whether this patient would be shown **Verify now** right now (`personaOffered`). */
  offered: z.boolean(),
})

export const getPersonaPilot = oc.route({ method: 'GET', path: '/v2/super/persona-pilot' }).output(
  z.object({
    flag: flagStateSchema,
    persona: z.object({
      configured: z.boolean(),
      environment: z.enum(['sandbox', 'production']).optional(),
      /** What to set when not configured — variable names only, never values. */
      missing: z.array(z.string()),
      problem: z.string().optional(),
    }),
    members: z.array(cohortMemberSchema),
  }),
)

export const enrollPersonaPilotPatient = oc
  .route({ method: 'POST', path: '/v2/super/persona-pilot/members' })
  .input(z.object({ patientId: z.string().trim().min(1) }))
  .output(z.object({ changed: z.boolean() }))

export const removePersonaPilotPatient = oc
  .route({ method: 'POST', path: '/v2/super/persona-pilot/members/{patientId}/remove' })
  .input(
    z.object({
      patientId: z.string().trim().min(1),
      reason: z.string().trim().max(200).optional(),
    }),
  )
  .output(z.object({ changed: z.boolean() }))
